import Api from "../axios"

export const getGames = async (filter, page, pageSize) => {
    return  await Api.get(`Game/AllGames?status=${filter}&pageNumber=${page}&pageSize=${pageSize}`);

  
  };
  